import { IToast } from "./toastTypes";
import { createAction } from "@reduxjs/toolkit";

export const showErrorToast = createAction<string>("toast/showErrorToast");
export const showInfoToast = createAction<string>("toast/showInfoToast");
export const showSuccessToast = createAction<string>("toast/showSuccessToast");
export const addToastToState = createAction<IToast>("toast/addToState");
export const removeToast = createAction<{ id: string }>("toast/remove");